import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
//import { applyPolyfills, defineCustomElements } from './../node_modules/@alightengineering/awlds-ui-lib/dist/loader'

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
declare var require: any
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// applyPolyfills().then(() => {
//   defineCustomElements(window);
// });
